import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=b2b32bec&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=b2b32bec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b32bec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2b32bec')) {
      api.createRecord('b2b32bec', component.options)
    } else {
      api.reload('b2b32bec', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=b2b32bec&scoped=true&", function () {
      api.rerender('b2b32bec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2C5LnIT3WcwM9/JS/comp/SearchFilterTokens.vue"
export default component.exports